;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { personalizedResource } from '@/lib/resources/personalized-resource';
import { normalizeVideoData } from '@/lib/helpers/normalize-video-data'

// types
import type { ContentServiceVideoObject } from '@/lib/types/api/content-service'
import type { VideoClass } from '@/lib/types/api/video'

export const myListVideos = personalizedResource<VideoClass>({
  key: 'myListVideos',
  endpoint: '/api/profile/my-list-videos/',
  // The only resource that reshapes its response.
  select: (json) => {
    const { myListVideosData } = json as { myListVideosData: ContentServiceVideoObject[] | null }
    return myListVideosData ? myListVideosData.map((video) => normalizeVideoData(video)) : null
  },
})
